export const floatingBarInit=()=>{
 let scrollTimeout;
  const floatingBar = document.getElementById('floatingBar');

  if(!floatingBar){
    return;
  }
  
  let isMobileMode = null; // track current mode
  let scrollHandler = null;

  function enableScrollBehavior() {
    if (scrollHandler) return; // already active

    scrollHandler = () => {
      floatingBar.style.bottom = '-100px';
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        if (window.scrollY > 200) {
          floatingBar.style.bottom = '0';
        }
      }, 700);
    };

    window.addEventListener('scroll', scrollHandler);
  }

  function disableScrollBehavior() {
    if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
      scrollHandler = null;
      floatingBar.style.bottom = '-100px';
    }
  }

  function checkScreenMode() {
    const isNowMobile = window.innerWidth <= 992;
    if (isNowMobile !== isMobileMode) {
      isMobileMode = isNowMobile;
      if (isMobileMode) {
        enableScrollBehavior();
      } else {
        disableScrollBehavior();
      }
    }
  }

  // Run on load and whenever screen is resized
  window.addEventListener('resize', checkScreenMode);
  window.addEventListener('load', checkScreenMode);
  }
 
